module.exports = __webpack_public_path__ + "static/media/copy.88ca6f16.svg";